import styled from "styled-components";

export const PeopleDetailsWrapper = styled.div`
    & > .row > div{
        margin-bottom: 20px;
    }
    .peopleDetailsContainer{
        display: flex;
        width: 100%;
        background-color: var(--white);
        border-radius: 10px;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
        justify-content: space-between;
        padding: 24px;
        .peopleDetailsInner{
            display: flex;
            gap: 12px;
            width: 100%;
            img{
                max-width: 64px;
                min-width: 64px;
                height: 64px;
            }
            .peopleDetails{
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                width: 100%;
                .peopleNameLocation{
                    display: flex;
                    width: 100%;
                    gap: 20px;
                    align-items: center;
                    justify-content: space-between;
                    .peopleNameTime{
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        width: 100%;
                    }
                    .peopleLocationRole{
                        display: flex;
                        align-items: center;
                        & span:first-child{
                            position: relative;
                            padding-right: 16px;
                            margin-right: 16px;
                            &::after{
                                content: "";
                                height: 13px;
                                width: 1px;
                                background-color: var(--lightGrey);
                                position: absolute;
                                right: 0;
                                top: auto;
                                bottom: auto;
                            }
                        }
                        body.rtl & span:first-child{
                            padding-right: 0;
                            padding-left: 16px;
                            margin-right: 0;
                            margin-left: 16px;
                            &::after{
                                right: auto;
                                left: 0;
                            }
                        }
                    }
                    .peopleMainRoleWrapper{
                        display: flex;
                        width: 100%;
                        gap: 16px;
                        flex-wrap: wrap;
                        margin-top: 15px;
                        .peopleMainRole{
                            padding: 5px 16px;
                            background-color: var(--bg);
                            border-radius: 8px;
                            border: 1px solid var(--border)
                        }
                    }
                    
                }
                .peopleMainRoleWrapper{
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    margin-top: 16px;
                    .peopleMainRole{
                        display: flex;
                        width: fit-content;
                        border: 1px solid var(--border);
                        background-color: var(--bg);
                        border-radius: 8px;
                        padding: 5px 15px;  
                    }
                }
            }
        }
    }
`